import { RemoteConfig } from 'firebase/remote-config';
import {
  getRemoteConfig,
  fetchAndActivate,
  getString,
} from 'firebase/remote-config';
import { useFirebaseApp } from './useFirebaseApp';
import { useEffect, useState } from 'react';

export type MyBrightlinkRemoteConfig = {
  dataCollectionProviders: Set<string>;
  dataCollectionClientSfIds: Set<string>;
  scheduleProviders: Set<string>;
  scheduleClientSfIds: Set<string>;
  schedulingContactNumber: string;
};

const valueToSetMapper = (value: string) =>
  new Set<string>(
    value
      .split(/\s*,\s*/)
      .map((elem) => elem.trim())
      .filter((elem) => !!elem),
  );

const remoteConfigFromFirebase = (
  firebaseRemoteConfig: RemoteConfig,
): MyBrightlinkRemoteConfig => ({
  dataCollectionProviders: valueToSetMapper(
    getString(firebaseRemoteConfig, 'dataCollectionProviders'),
  ),
  dataCollectionClientSfIds: valueToSetMapper(
    getString(firebaseRemoteConfig, 'dataCollectionClientSfIds'),
  ),
  scheduleProviders: valueToSetMapper(
    getString(firebaseRemoteConfig, 'scheduleProviders'),
  ),
  scheduleClientSfIds: valueToSetMapper(
    getString(firebaseRemoteConfig, 'scheduleClientSfIds'),
  ),
  schedulingContactNumber: getString(
    firebaseRemoteConfig,
    'scheduleClientSfIds',
  ),
});

export const useFetchFirebaseRemoteConfig = () => {
  const firebaseApp = useFirebaseApp();
  const [remoteConfig, setRemoteConfig] =
    useState<MyBrightlinkRemoteConfig | null>(null);
  useEffect(() => {
    const fetchRemoteConfig = async () => {
      const remoteConfig = getRemoteConfig(firebaseApp);
      await fetchAndActivate(remoteConfig);
      return remoteConfig;
    };
    fetchRemoteConfig().then((remoteConfig) =>
      setRemoteConfig(remoteConfigFromFirebase(remoteConfig)),
    );
  }, [firebaseApp]);
  return { remoteConfig };
};
